import React, { useState, useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Navbar from './layout/Navbar'
import Sidebar from './layout/Sidebar'
import ProjectsList from './projects/ProjectsList'
import ArchivedProjectsList from './projects/ArchivedProjectsList'
import ProjectShow from './projects/ProjectShow'
import ProjectForm from './projects/ProjectForm'
import UsersList from './users/UsersList'
import UserForm from './users/UserForm'
import WorkStagesList from './workstages/WorkStagesList'
import WorkStageForm from './workstages/WorkStageForm'
import WorkStageEdit from './workstages/WorkStageEdit'
import Settings from './settings/Settings'
import ChatsList from './chats/ChatsList'
import ChatHub from './chats/ChatHub'
import ChatMessages from './chats/ChatMessages'
import ChatStage from './chats/ChatStage'
import ChatStageTasks from './chats/ChatStageTasks'
import ChatStageActs from './chats/ChatStageActs'

const App = () => {
  const [currentUser, setCurrentUser] = useState(null)

  useEffect(() => {
    // Load current user
    fetch('/api/current_user.json')
      .then(res => res.json())
      .then(data => setCurrentUser(data))
      .catch(err => console.error('Error loading current user:', err))
  }, [])

  return (
    <>
      <Navbar currentUser={currentUser} />
      <Sidebar currentUser={currentUser} mobile={true} />

      {currentUser && (
        <div className="container-fluid p-0">
          <div className="row g-0 flex-nowrap">
            <div className="col-lg-2 sidebar-wrapper">
              <Sidebar currentUser={currentUser} mobile={false} />
            </div>
            <div className="col-lg-10 main-content">
              <main className="container mt-4">
                <Routes>
                  <Route path="/" element={<Navigate to="/projects" replace />} />

                  {/* Projects */}
                  <Route path="/projects" element={<ProjectsList />} />
                  <Route path="/projects/new" element={<ProjectForm currentUser={currentUser} />} />
                  <Route path="/projects/:id" element={<ProjectShow />} />
                  <Route path="/projects/:id/edit" element={<ProjectForm currentUser={currentUser} />} />

                  {/* Archive */}
                  <Route path="/archive" element={<ArchivedProjectsList />} />

                  {/* Chats */}
                  <Route path="/chats" element={<ChatsList />} />
                  <Route path="/chats/:id" element={<ChatHub currentUser={currentUser} />} />
                  <Route path="/chats/:id/messages" element={<ChatMessages currentUser={currentUser} />} />
                  <Route path="/chats/:id/stages/:stageId" element={<ChatStage />} />
                  <Route path="/chats/:id/stages/:stageId/tasks" element={<ChatStageTasks />} />
                  <Route path="/chats/:id/stages/:stageId/acts" element={<ChatStageActs />} />

                  {/* Users */}
                  <Route path="/users" element={<UsersList currentUser={currentUser} />} />
                  <Route path="/users/new" element={<UserForm />} />
                  <Route path="/users/:id/edit" element={<UserForm />} />

                  {/* Work Stages */}
                  <Route path="/work_stages" element={<WorkStagesList />} />
                  <Route path="/work_stages/new" element={<WorkStageForm />} />
                  <Route path="/work_stages/:id/edit" element={<WorkStageEdit />} />

                  {/* Settings (redirect to Rails view for now) */}
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/settings/edit" element={<Settings />} />
                </Routes>
              </main>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default App
